import { SelectOption } from '@/components/elements/select'

export const genderMap: SelectOption[] = [
    { label: 'Hombre', value: 'Hombre' },
    { label: 'Mujer', value: 'Mujer' },
    { label: 'Unisex', value: 'Unisex' },
]
